import { ReactNode } from "react";

import { Button } from "capitalrx-components";

import { GeneralTypes } from "@/types";

const listTableHeaders: Array<GeneralTypes.TableHeader> = [
  {
    key: "npi",
    label: "Service Provider ID",
  },
  {
    key: "name",
    label: "Provider Name",
  },
  {
    key: "address_line_1",
    label: "Street Address 1",
  },
  {
    key: "address_line_2",
    label: "Street Address 2",
  },
  {
    key: "city",
    label: "City",
  },
  {
    key: "state",
    label: "State",
  },
  {
    key: "zip",
    label: "Zip Code",
    formatter: (value: string): string => {
      // only display first 5 digits of zip code
      return value.slice(0, 5);
    },
  },
  {
    key: "action",
    label: "",
    className: "right-span",
    formatter: (): ReactNode => {
      const component = (
        <Button buttonStyle="outline" color="darkblue" size="small">
          <span aria-hidden className="caprx-icon-input-plus" />
          ADD
        </Button>
      );
      return component;
    },
  },
];

export default listTableHeaders;
